import { i18n } from "@tellescope/i18n";
import type { PopupDismissalPeriod } from "./blocks";

/**
 * Variant styles for popup blocks (background and border colors).
 * Used in both PopupBlock renderer and PopupBlockEditor preview.
 */
export const POPUP_VARIANT_STYLES: Record<string, string> = {
  info: "bg-blue-50 border-blue-200",
  success: "bg-green-50 border-green-200",
  warning: "bg-yellow-50 border-yellow-200",
  error: "bg-red-50 border-red-200",
  neutral: "bg-gray-50 border-gray-200",
};

/**
 * Duration in milliseconds for each dismissal period.
 * Used to calculate when a popup should reappear.
 */
export const PERIOD_DURATIONS: Record<PopupDismissalPeriod, number> = {
  "1h": 60 * 60 * 1000,
  "1d": 24 * 60 * 60 * 1000,
  "7d": 7 * 24 * 60 * 60 * 1000,
  "30d": 30 * 24 * 60 * 60 * 1000,
};

/**
 * Select options for dismissal periods with translated labels.
 * The i18n.t() calls use literal strings for static extraction.
 */
export const getDismissalPeriodOptions: () => { value: PopupDismissalPeriod; label: string }[] = () => [
  { value: "1h", label: i18n.t("1 hour") },
  { value: "1d", label: i18n.t("1 day") },
  { value: "7d", label: i18n.t("7 days") },
  { value: "30d", label: i18n.t("30 days") },
];
